import { render } from "./LaravelVueDatatablesLoader.vue?vue&type=template&id=623e2853"
import script from "./LaravelVueDatatablesLoader.vue?vue&type=script&lang=js"
export * from "./LaravelVueDatatablesLoader.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__